module.exports = __webpack_public_path__ + "img/05.2edbf25f.png";